(function() {
  if (App.angularApp == null) {
    return;
  }

  App.angularApp.directive('mfUibBtnRadioYesNo', function() {
    return {
      require: 'ngModel',
      restrict: 'AE',
      template: function(element, attrs) {
        var buttonAttrs, classes;
        buttonAttrs = "ng-model='" + attrs.ngModel + "'";
        if (attrs.ngDisabled != null) {
          buttonAttrs += " ng-disabled='" + attrs.ngDisabled + "'";
        }
        if (attrs.uncheckable != null) {
          buttonAttrs += " uncheckable";
        }
        if (attrs.classes != null) {
          classes = attrs.classes;
        }
        return "<div class='btn-group " + classes + "'>\n    <button type='button'\n        class='btn btn-group-split'\n        ng-class='{ \"btn-primary\": (" + attrs.ngModel + ") === true }'\n        uib-btn-radio='true'\n        " + buttonAttrs + "\n    >\n        Yes\n    </button>\n    <button type='button'\n        class='btn btn-group-split'\n        ng-class='{ \"btn-danger\": (" + attrs.ngModel + ") === false }'\n        uib-btn-radio='false'\n        " + buttonAttrs + "\n    >\n        No\n    </button>\n</div>";
      },
      replace: true,
      link: function(scope, ele, attrs, ngModelCtrl) {}
    };
  });

}).call(this);
